import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MaxBrainTag } from '../../models/tag.model';
import { TagMultiSelectService } from '../../services/multi-select.service';

@Component({
    selector: 'app-tag-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TagMultiSelectComponent implements OnInit {
    @Input()
    tags: MaxBrainTag[];

    @Input()
    storageKey: string;

    @ViewChild('auto')
    matAutocomplete: MatAutocomplete;

    constructor(public tagMultiSelectService: TagMultiSelectService, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.storageKey) {
            this.tagMultiSelectService.setFromStorage(this.storageKey);
            this.cdr.detectChanges(); // Ensure the component reflects the changes
        }
    }

    trackById(index: number, item: MaxBrainTag): string {
        return item.id;
    }

    compareTags(tag1: MaxBrainTag, tag2: MaxBrainTag): boolean {
        return tag1 && tag2 ? tag1.id === tag2.id : tag1 === tag2;
    }
}
